import api from './api';

export interface EInvoice {
  id: number;
  invoice_id: number;
  invoice_number: string;
  customer_name?: string;
  total_amount: number;
  e_invoice_id?: string;
  status: 'pending' | 'issued' | 'cancelled';
  issue_date?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateEInvoiceData {
  invoice_id: number;
  e_invoice_id?: string;
  status?: 'pending' | 'issued' | 'cancelled';
  issue_date?: string;
}

export const eInvoiceService = {
  async getAll(params?: { page?: number; per_page?: number; search?: string }) {
    const response = await api.get('/e-invoices', { params });
    return response.data;
  },

  async getById(id: number): Promise<EInvoice> {
    const response = await api.get(`/e-invoices/${id}`);
    return response.data;
  },

  async create(data: CreateEInvoiceData): Promise<EInvoice> {
    const response = await api.post('/e-invoices', data);
    return response.data;
  },

  async update(id: number, data: Partial<CreateEInvoiceData>): Promise<EInvoice> {
    const response = await api.put(`/e-invoices/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/e-invoices/${id}`);
  },

  async issue(id: number): Promise<{ e_invoice_id: string; status: string }> {
    const response = await api.post(`/e-invoices/${id}/issue`);
    return response.data;
  },

  async getStatus(invoiceId: number): Promise<{ status: string; e_invoice_id?: string }> {
    const response = await api.get(`/e-invoices/${invoiceId}/status`);
    return response.data;
  },

  async cancel(invoiceId: number): Promise<void> {
    await api.post(`/e-invoices/${invoiceId}/cancel`);
  },

  async download(invoiceId: number): Promise<{ download_url: string }> {
    const response = await api.get(`/e-invoices/${invoiceId}/download`);
    return response.data;
  }
};

